export const RENDERER_CONFIG = {
	SCENE_BACKGROUND: 0xf8f9fa,
	HELPERS_COLOR: 0x060606,
	LIGHTS_COLOR: 0xffffff,
	CONTROLS: {
		PAN_SPEED: 0.8,
		MAX_POLAR_ANGLE: 85,
		SCREEN_SPACE_PANNING: false,
		ROTATE_SPEED: 10,
		ROTATE_TIME: 500,
		MIN_DISTANCE: 1.5,
		MAX_DISTANCE: 20,
	},
	CAMERA_DISTANCE_TICK: 2.5,
	INITIAL_ZOOM: 1,
	DRACO_DECODER_PATH: 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/',
	SELECTABLE_LAYER: 2,
	OUTLINE_PARAMS: {
		edgeStrength: 15,
		edgeGlow: 0,
		edgeThickness: 1,
		pulsePeriod: 0,
		visibleEdgeColor: 0xffffff,
		hiddenEdgeColor: 0xffffff,
	},
	CONNECT_NEARBY_SLOT_THRESHOLD: 0.1,
} as const;
